import { TGetProviderAppointmentListInput } from 'types/inbox';
import { Request } from '../request';

export const getConversationsList = (current: number, size: number, clientId?: string) => Request.get({ url: '/schedule-server/provider/conversations', params: clientId ? { current, size, clientId } : { current, size } });

export const markReadForConversation = (conversationId: string) => Request.post({ url: '/schedule-server/provider/conversations/read-all-message', params: { conversationId } });

export const getAllUnreadAmount = () => Request.get({ url: '/schedule-server/provider/conversations/unread' });

//conversationId=1287_106527&pageSize=20&cursor
export type TGetConversationMessageList = {
    conversationId: string;
    size?: number;
    cursor?: string;
};

export const getConversationMessageList = (params: TGetConversationMessageList) => Request.get({ url: '/schedule-server/provider/conversations/messages', params: { ...params } });

type TSendMessage = {
    providerId: number | string,
    clientId: number | string,
    message: string
};

export const sendMessage = (param: TSendMessage) => Request.post({
    url: '/schedule-server/provider/conversations/sendMessage',
    params: {
        providerId: param.providerId,
        clientId: param.clientId,
        message: param.message,
    },
});

export const getOrCreateConversation = (providerId: number, clientId: number) => Request.post({ url: '/schedule-server/provider/conversations', params: { providerId, clientId } });

export const getProviderAppointmentList = (data: TGetProviderAppointmentListInput) => Request.post({ url: `/schedule-server/client/appointment/${data.clientId}/list`, params: data });

export const getProviderAppointmentListCount = (clientId: number) => Request.get({ url: `/schedule-server/client/appointment/${clientId}/counts` });
